<i [ngClass]="rating_class"></i>